(function(){
  var box=document.getElementById('pm-fbt');if(!box||box.dataset.ready)return;box.dataset.ready='1';
  var main;try{main=JSON.parse(document.getElementById('pm-fbt-main').textContent);}catch(e){return;}
  if(!main.url&&main.handle)main.url='/products/'+main.handle;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var META=4900;
  function money(c){return 'S/ '+(c/100).toFixed(2);}
  function esc(s){return String(s).replace(/[&<>"']/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];});}
  function img(p,v){
    var u=(v&&v.featured_image&&(v.featured_image.src||v.featured_image))||p.featured_image||(p.images&&p.images[0])||'';
    if(u&&typeof u==='object')u=u.src||'';
    if(!u)return '';
    if(u.indexOf('//')===0)u='https:'+u;
    return u+(u.indexOf('?')>-1?'&':'?')+'width=300';
  }
  function avail(p){return (p.variants||[]).filter(function(v){return v.available;});}
  function get(intent){
    return fetch(root+'recommendations/products.json?product_id='+main.id+'&limit=6&intent='+intent).then(function(r){return r.ok?r.json():{products:[]};}).then(function(d){return d.products||[];}).catch(function(){return [];});
  }
  function pick(list,out){
    list.forEach(function(p){
      if(out.length>=2||p.id===main.id||!avail(p).length)return;
      if(out.some(function(x){return x.id===p.id;}))return;
      out.push(p);
    });
    return out;
  }
  get('complementary').then(function(c){
    var out=pick(c,[]);
    if(out.length>=2)return out;
    return get('related').then(function(r){return pick(r,out);});
  }).then(function(recs){
    if(!recs.length||!avail(main).length)return;
    var cur=document.querySelector('form[action*="/cart/add"] [name="id"]');
    var items=[main].concat(recs).map(function(p,i){
      var vs=avail(p),sel=vs[0];
      if(i===0&&cur){vs.forEach(function(v){if(String(v.id)===String(cur.value))sel=v;});}
      return {p:p,vs:vs,v:sel,on:true};
    });
    render(items);
  });
  function render(items){
    var pics=items.map(function(it,i){
      var u=img(it.p,it.v);
      return (i?'<span class="pm-fbt-plus">+</span>':'')+'<a class="pm-fbt-img'+(it.on?'':' off')+'" href="'+esc(it.p.url||'#')+'">'+(u?'<img src="'+esc(u)+'" alt="'+esc(it.p.title)+'" loading="lazy" width="150" height="150">':'')+'</a>';
    }).join('');
    var rows=items.map(function(it,i){
      var opts=it.vs.length>1?'<select data-i="'+i+'">'+it.vs.map(function(v){return '<option value="'+v.id+'"'+(v.id===it.v.id?' selected':'')+'>'+esc(v.title)+'</option>';}).join('')+'</select>':'';
      var cmp=it.v.compare_at_price&&it.v.compare_at_price>it.v.price?' <s>'+money(it.v.compare_at_price)+'</s>':'';
      return '<li><label><input type="checkbox" data-i="'+i+'"'+(it.on?' checked':'')+'> <span class="pm-fbt-t">'+(i===0?'Este producto: ':'')+(i===0?esc(it.p.title):'<a href="'+esc(it.p.url||'#')+'">'+esc(it.p.title)+'</a>')+'</span></label> '+opts+' <span class="pm-fbt-pr">'+money(it.v.price)+cmp+'</span></li>';
    }).join('');
    var tot=0,ahorro=0,n=0;
    items.forEach(function(it){if(!it.on)return;n++;tot+=it.v.price;if(it.v.compare_at_price>it.v.price)ahorro+=it.v.compare_at_price-it.v.price;});
    var extra='';
    if(n){extra=(ahorro>0?'<p class="pm-fbt-ah">Ahorras '+money(ahorro)+'</p>':'')+(tot>=META?'<p class="pm-fbt-env">Con esta combinación tu envío es gratis</p>':'<p class="pm-fbt-env">Te faltan '+money(META-tot)+' para envío gratis</p>');}
    box.querySelector('.pm-fbt-body').innerHTML='<div class="pm-fbt-top"><div class="pm-fbt-pics">'+pics+'</div><div class="pm-fbt-buy"><p class="pm-fbt-tot">Precio total: <b>'+money(tot)+'</b></p>'+extra+'<button type="button" class="button pm-fbt-btn"'+(n?'':' disabled')+'>'+(n>1?'Agregar los '+n+' al carrito':'Agregar al carrito')+'</button><p class="pm-fbt-msg" role="status"></p></div></div><ul class="pm-fbt-list">'+rows+'</ul>';
    box.hidden=false;
    box.querySelectorAll('input[type=checkbox]').forEach(function(c){c.addEventListener('change',function(){items[c.dataset.i].on=c.checked;render(items);});});
    box.querySelectorAll('select').forEach(function(s){s.addEventListener('change',function(){var it=items[s.dataset.i];it.vs.forEach(function(v){if(String(v.id)===s.value)it.v=v;});render(items);});});
    box.querySelector('.pm-fbt-btn').addEventListener('click',function(){add(items,this);});
  }
  function add(items,btn){
    var sel=items.filter(function(it){return it.on;}).map(function(it){return {id:it.v.id,quantity:1};});
    if(!sel.length)return;
    btn.disabled=true;var msg=box.querySelector('.pm-fbt-msg');msg.textContent='Agregando...';
    var drawer=document.querySelector('cart-drawer');
    var body={items:sel};if(drawer)body.sections='cart-drawer,cart-icon-bubble';
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
    .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
    .then(function(res){
      btn.disabled=false;
      if(!res.ok){msg.textContent=res.d.description||res.d.message||'No se pudo agregar. Intenta de nuevo.';return;}
      msg.textContent='Agregado al carrito';
      if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){try{publish(PUB_SUB_EVENTS.cartUpdate,{source:'pm-fbt',cartData:res.d});}catch(e){}}
      if(drawer&&res.d.sections&&typeof drawer.renderContents==='function'){try{drawer.renderContents(res.d);return;}catch(e){}}
      window.location.href=root+'cart';
    }).catch(function(){btn.disabled=false;msg.textContent='No se pudo agregar. Intenta de nuevo.';});
  }
})();
